export default class Header {
  constructor() {
    this.DOM = {}
    this.timerId = null

    this.init()
  }

  init() {
    this.cacheSelectors()
    this.bindEvents()
  }

  cacheSelectors() {
    this.DOM.$body = $('body')
    this.DOM.$header = $('.header')
    this.DOM.$navLink = $('.js-headerNavLink')
    this.DOM.$headerSubmenu = $('.header-submenu')
  }

  bindEvents() {
    $(window).on('load scroll', () => this.headerOnScroll())
    this.DOM.$navLink.on('click', (e) => this.menuClick(e))
    this.DOM.$navLink.on('mouseenter', (e) => this.menuHover(e))
    this.DOM.$navLink.on('mouseleave', () => this.menuLeave())
    this.DOM.$headerSubmenu.on('mouseenter', () => this.submenuHover())
    this.DOM.$headerSubmenu.on('mouseleave', () => {
      this.DOM.$headerSubmenu.removeClass('is_active')
    })
  }

  menuClick(e) {
    const current = $(e.currentTarget)

    if ($(window).width() <= 1149 && !current.hasClass('is_active')) {
      e.preventDefault()
    }

    this.DOM.$navLink.not(current).removeClass('is_active')

    current.addClass('is_active')
  }

  menuHover(e) {
    const current = $(e.currentTarget)
    const id = current.data('id')
    const menu = $(`${id}`)

    menu.addClass('is_active')

    this.DOM.$body.addClass('is-submenu-hover')

    // this.DOM.$headerOverlay
    //   .css('height', subHeight)
    //   .addClass('is_active')
  }

  menuLeave() {
    const self = this
    this.timerId = setTimeout(() => {
      self.DOM.$headerSubmenu.removeClass('is_active')
      self.DOM.$body.removeClass('is-submenu-hover')
      // self.DOM.$headerOverlay.removeClass('is_active')
    }, 500)
  }

  submenuHover() {
    clearTimeout(this.timerId)
  }

  headerOnScroll() {
    const scrolled = $(window).scrollTop()

    if (scrolled > 0) {
      this.DOM.$header.addClass('is_sticky')
    } else {
      this.DOM.$header.removeClass('is_sticky')
    }
  }
}
